export enum TenantUserRole {
  Owner,
  Admin,
  Member,
  Guest,
}
